<!-- =========================================================================================
  File Name: VehicleCreate.vue
  Description: Vehicle Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="breakUpdatePermission" id="page-user-edit">
		<vx-card>
			<break-edit-tab v-if="breakData !== null" class="mt-4" :dataBreak="breakData" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import BreakEditTab from "./BreakEditTab.vue";

export default {
	components: {
		NotPermission,
		BreakEditTab,
	},
	data() {
		return {
			breakData: null,
		};
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		this.getBreakById(parseInt(this.$route.params.id));
	},
	computed: {
		breakUpdatePermission() {
			return this.$store.getters.checkPermission("BREAKS_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getBreakById(breakId) {
			this.openLoading();
			this.$store
				.dispatch("moduleBreaks/findBreaksFilter", {id: [breakId]})
				.then((res) => {
					this.breakData = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
